import React from 'react';
import styles from './M3DevicesMockup.module.css';

/** Vector device lineup (desktop, tablet, phone) — replaces legacy product photo. */
export default function M3DevicesMockup() {
  return (
    <div className={styles.wrap} aria-hidden="true">
      <svg
        className={styles.svg}
        viewBox="0 0 640 380"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="m3dev-screen" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#1e2028" />
            <stop offset="100%" stopColor="#12141a" />
          </linearGradient>
          <linearGradient id="m3dev-accent" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#edc917" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#edc917" stopOpacity="0.15" />
          </linearGradient>
          <filter id="m3dev-shadow" x="-8%" y="-8%" width="116%" height="116%">
            <feDropShadow dx="0" dy="12" stdDeviation="16" floodColor="#000" floodOpacity="0.35" />
          </filter>
        </defs>

        {/* Desktop */}
        <g filter="url(#m3dev-shadow)" transform="translate(88 24)">
          <rect x="0" y="0" width="420" height="260" rx="10" fill="#2c2f38" />
          <rect x="8" y="8" width="404" height="228" rx="6" fill="url(#m3dev-screen)" stroke="#fff" strokeOpacity="0.06" />
          <rect x="24" y="24" width="88" height="8" rx="2" fill="#fff" fillOpacity="0.12" />
          <rect x="24" y="42" width="160" height="6" rx="2" fill="#fff" fillOpacity="0.06" />
          <rect x="24" y="68" width="120" height="72" rx="6" fill="#0c0d10" stroke="#fff" strokeOpacity="0.05" />
          <rect x="32" y="118" width="48" height="10" rx="2" fill="url(#m3dev-accent)" />
          <rect x="156" y="68" width="228" height="100" rx="6" fill="#0c0d10" stroke="#fff" strokeOpacity="0.05" />
          {[0, 1, 2, 3, 4].map((i) => (
            <rect
              key={`db-${i}`}
              x={168 + i * 38}
              y={138 - i * 8}
              width="22"
              height={28 + i * 8}
              rx="4"
              fill="#edc917"
              fillOpacity={0.12 + i * 0.1}
            />
          ))}
          <rect x="196" y="248" width="28" height="18" rx="3" fill="#2c2f38" />
          <rect x="168" y="266" width="84" height="6" rx="2" fill="#2c2f38" />
        </g>

        {/* Tablet */}
        <g filter="url(#m3dev-shadow)" transform="translate(32 118) rotate(-8 90 200)">
          <rect x="0" y="0" width="180" height="248" rx="14" fill="#383b45" />
          <rect x="10" y="14" width="160" height="212" rx="4" fill="url(#m3dev-screen)" stroke="#fff" strokeOpacity="0.07" />
          <rect x="22" y="26" width="72" height="6" rx="2" fill="#fff" fillOpacity="0.1" />
          <rect x="22" y="40" width="120" height="5" rx="2" fill="#fff" fillOpacity="0.05" />
          <rect x="22" y="58" width="136" height="88" rx="6" fill="#0c0d10" stroke="#fff" strokeOpacity="0.04" />
          <rect x="30" y="128" width="56" height="8" rx="2" fill="#edc917" fillOpacity="0.35" />
          <circle cx="90" cy="238" r="3" fill="#fff" fillOpacity="0.15" />
        </g>

        {/* Phone */}
        <g filter="url(#m3dev-shadow)" transform="translate(468 132) rotate(10 44 160)">
          <rect x="0" y="0" width="88" height="200" rx="16" fill="#3a3d47" />
          <rect x="5" y="10" width="78" height="168" rx="3" fill="url(#m3dev-screen)" stroke="#fff" strokeOpacity="0.08" />
          <rect x="36" y="18" width="16" height="4" rx="2" fill="#fff" fillOpacity="0.12" />
          <rect x="14" y="32" width="60" height="6" rx="2" fill="#fff" fillOpacity="0.08" />
          <rect x="14" y="46" width="60" height="72" rx="5" fill="#0c0d10" stroke="#fff" strokeOpacity="0.05" />
          <rect x="22" y="98" width="36" height="6" rx="2" fill="#edc917" fillOpacity="0.4" />
          <rect x="14" y="118" width="44" height="4" rx="1" fill="#fff" fillOpacity="0.06" />
          <rect x="14" y="128" width="32" height="4" rx="1" fill="#fff" fillOpacity="0.04" />
        </g>
      </svg>
    </div>
  );
}
